import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ktbtpqmu8: FaireProductEntity = {
  token: "p_5ktbtpqmu8",
  type: "product",
  name: "La Vie Parisienne Beach Girls Mini Matchbox 60Pk - ANN433",
  brandName: "World Buyers",
  imageUrl:
    "https://cdn.faire.com/fastly/bc96d192e87436e80bba8495670ddc118590679e63c15732c4b958af272e13e3.jpeg",
  priceDollars: 0.6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0ba681d77ebac758368747c384944bda421ac31a4cf8e9343c91219dc50ef5d5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
